import React from 'react'
import { pick } from 'lodash-es'
// import { Checkbox } from '@ow/comps'
import { Checkbox } from '@mantine/core'
import { useListStore } from '@ow/ditto-core'
import Render from '../../renders/inline-renders'
import Operate from '../basetable/TableHeaderOperate'
import { canInlineEdit, getCellEvent } from '../utils'
// import InlineEdit from '../../forms/inline'
// import TableCell from '../basetable/TableCell'

// TODO:
// 这里的参数预计加一个 active 的参数来判断当前格子是否被选中或者点击, className 中会直接添加 active 这个类名
// 各个单元格对 active 如果有特殊处理可以根据 active 来判断, 如果有使用active做显隐处理的最好优先用 css 控制(当然这个得灵活控制)
// 因为如果状态完全维护在组件内部, 或者用 css 处理, 该组件就不需要刷新
// renderRowCell调用并传入参数
const Cell = React.memo((cellProps) => {
  // isScrolling,
  // cellData,
  // columns,
  // column,
  // columnIndex,
  // rowData,
  // rowIndex,
  // container: this,
  const {
    column,
    cellData,
    className,
    rowData = {},
    columns = [],
    rowIndex,
  } = cellProps

  const { fields: columnsRaw, inlineEdit = {} } = useListStore((state) =>
    pick(state, ['fields', 'inlineEdit'])
  )

  const fields = columns.map((x) => x.fieldDefs)
  const { defs = {}, hooks } = column

  const finalFields = [...columnsRaw, ...fields].filter((v) => v)
  let finalDefs = defs
  if (rowData && rowData.bind_raw_slug && !defs.bind_primary) {
    finalDefs =
      finalFields.find((v) => v.slug === rowData.bind_raw_slug) || defs
  }

  // 处理合并的字段
  if (
    rowData &&
    rowData.bind_merge_raw_slugs &&
    rowData.bind_merge_raw_slugs.length > 0 &&
    !defs.bind_primary
  ) {
    finalDefs = {
      type: 'product',
      renderType: 'product',
      slug: rowData.bind_merge_raw_slugs[0],
      productSlugs: rowData.bind_merge_raw_slugs,
      productFields: finalFields.filter((v) => {
        return rowData.bind_merge_raw_slugs.includes(v.slug)
      }),
      payload: defs.operators.payload,
    }
  }

  const cellRender = (
    <Render
      value={cellData}
      // defs={finalDefs}
      defs={{ ...finalDefs, operators: defs.operators }}
      rowData={rowData}
      rowIndex={rowIndex}
      fields={finalFields}
      className={className}
      hooks={hooks}
    />
  )

  if (column.defs.type === 'selection') {
    return (
      <div
        className={className}
        style={{
          width: '100%',
          display: 'flex',
          // alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {cellRender}
      </div>
    )
  }

  // 目前只允许行内编辑且可弹出框的类型呈编辑状态
  if (
    canInlineEdit({
      defs: finalDefs,
      rowData,
      ...inlineEdit,
    })
  ) {
    return (
      // <InlineEdit opts={defs} data={rowData} fields={fields}>
      <div
        className="cursor-pointer h-full w-full flex items-center gap-1"
        onClick={() => {
          if (hooks && hooks.showTbInlineEdit) {
            hooks.showTbInlineEdit({ ...finalDefs, inline: true }, rowData)
          }
        }}
      >
        {cellRender}
        <svg
          title={`修改${defs.title}`}
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-pencil-minus"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="var(--ow-color-primary-700)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M8 20l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4z" />
          <path d="M13.5 6.5l4 4" />
          <path d="M16 18h4" />
        </svg>
      </div>
    )
  }

  // 可点击
  const cellEvent = getCellEvent({ defs: finalDefs, rowData, hooks })
  if (cellEvent) {
    return (
      <div className="cursor-pointer" onClick={cellEvent}>
        {cellRender}
      </div>
    )
  }

  return cellRender
})

const HeaderCell = (cellProps) => {
  const { column, className } = cellProps
  const { defs = {}, hooks = {}, title } = column || {}

  if (defs.type === 'selection') {
    const { selectedIds, dataCheckDisabled } = hooks
    const props = {}
    if (selectedIds && selectedIds.length === 0) {
      props.checked = false
    }
    return (
      <div
        className={className}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Checkbox
          disabled={dataCheckDisabled}
          styles={{ input: { cursor: 'pointer' } }}
          defaultChecked={defs.checked}
          {...props}
          onChange={(e) => {
            hooks.toggleCheckAll(e.target.checked)
          }}
        />
      </div>
    )
  }

  return (
    <div className={className}>
      <div className="flex items-center">{title}</div>
      {defs.operators && defs.operators.allow && (
        <div className="ml-3 cursor-pointer">
          <Operate hooks={hooks} defs={defs} operators={defs.operators} />
        </div>
      )}
    </div>
  )
}

export default {
  TableCell: Cell,
  TableHeaderCell: HeaderCell,
}
